import clsx from 'clsx';
import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

import styles from './AISearchSpinner.module.css';

/**
 * Animated spinner of the AI Lens icon.
 */
export function AISearchSpinner(): React.ReactElement {
    return (
        <div className={clsx('flex size-5 text-muted', styles.aiSearchSpinner)}>
            <Icon.AILens className="size-full" />
        </div>
    );
}
